/*
 * @Author: whb
 * @Date: 2023-01-11 18:59:15
 * @LastEditors: whb
 * @LastEditTime: 2023-01-12 10:09:23
 * @Description: Do not edit
 */
import i18n from '../i18n';
export const LANG_LIST = [
  {
    key: "en",
    value: "English",
  },
  {
    key: "cs",
    value: "čeština",
  },
  {
    key: "de",
    value: "Deutsch",
  },
  {
    key: "es",
    value: "Español",
  },
  {
    key: "fr",
    value: "Français",
  },
  {
    key: "it",
    value: "Italiano",
  },
  {
    key: "hu",
    value: "Magyar",
  },
  {
    key: "nl",
    value: "Nederlands",
  },
  {
    key: "pl",
    value: "Polski",
  },
  {
    key: "pt-BR",
    value: "Português",
  },
  {
    key: "ro",
    value: "Română",
  },
  {
    key: "fi",
    value: "Suomalainen",
  },
  {
    key: "sv",
    value: "Svenska",
  },
  {
    key: "el",
    value: "Ελληνικά",
  },
  {
    key: "in",
    value: "Bahasa Indonesia",
  },
  {
    key: "ms",
    value: "Melayu",
  },
  {
    key: "vi",
    value: "Tiếng Việt",
  },
  {
    key: "tr",
    value: "Türk",
  },
  {
    key: "ru",
    value: "Русский",
  },
  {
    key: "ar",
    value: "عربي",
  },
  {
    key: "hi-IN",
    value: "हिन्दी",
  },
  {
    key: "bn-IN",
    value: "বাংলা",
  },
  {
    key: "th",
    value: "ไทย",
  },
  {
    key: "zh-TW",
    value: "繁體中文",
  },
  {
    key: "ja",
    value: "日本語",
  },
  {
    key: "ko",
    value: "한국인",
  },
  {
    key: "pa-IN",
    value: "ਪੰਜਾਬੀ",
  },
  {
    key: "ml-IN",
    value: "മലയാളം",
  },
  {
    key: "gu",
    value: "ગુજરાતી",
  },
];
const EN_LANG_LIST = [{
  key: "en",
  value: "English",
  text: '英语'
}];
const EEA_LANG_LIST = [
  {
    key: "cs",
    value: "čeština",
    text: "捷克语",
  },
  {
    key: "de",
    value: "Deutsch",
    text: "德语",
  },
  ...EN_LANG_LIST,
  {
    key: "es",
    value: "Español",
    text: "西班牙语",
  },
  {
    key: 'fr',
    value: 'Français',
    text: '法语'
  },
  {
    key: "it",
    value: "Italiano",
    text: "意大利语",
  },
  {
    key: "hu",
    value: "Magyar",
    text: "匈牙利语",
  },
  {
    key: "nl",
    value: "Nederlands",
    text: "荷兰语",
  },
  {
    key: "pl",
    value: "Polski",
    text: "波兰语",
  },
  {
    key: "pt-BR",
    value: "Português",
    text: "葡萄牙语",
  },
  {
    key: "ro",
    value: "Română",
    text: "罗马尼亚语",
  },
  {
    key: "fi",
    value: "Suomalainen",
    text: "芬兰语",
  },
  {
    key: "sv",
    value: "Svenska",
    text: "瑞典语",
  },
  {
    key: "el",
    value: "Ελληνικά",
    text: "希腊语",
  },
];
const OTHER_LANG_LIST = [
  {
    key: "in",
    value: "Bahasa Indonesia",
    text: "印尼语",
  },
  {
    key: "ms",
    value: "Melayu",
    text: "马来语",
  },
  ...EN_LANG_LIST,
  {
    key: "es",
    value: "Español",
    text: "西班牙语",
  },
  {
    key: "pt-BR",
    value: "Português",
    text: "葡萄牙语",
  },
  {
    key: "vi",
    value: "Tiếng Việt",
    text: "越南语",
  },
  {
    key: "tr",
    value: "Türk",
    text: "土耳其语",
  },
  {
    key: "ru",
    value: "Русский",
    text: "俄语",
  },
  {
    key: "ar",
    value: "عربي",
    text: "阿拉伯语",
  },
  {
    key: "hi-IN",
    value: "हिन्दी",
    text: "印地语",
  },
  {
    key: "bn-IN",
    value: "বাংলা",
    text: "孟加拉语",
  },
  {
    key: "th",
    value: "ไทย",
    text: "泰语",
  },
  {
    key: "zh-TW",
    value: "繁體中文",
    text: "繁體中文",
  },
  {
    key: "ja",
    value: "日本語",
    text: "日本語",
  },
  {
    key: "ko",
    value: "한국인",
    text: "韩语",
  },
  {
    key: "pa-IN",
    value: "ਪੰਜਾਬੀ",
    text: "旁遮普语",
  },
  {
    key: "ml-IN",
    value: "മലയാളം",
    text: "马拉雅拉姆语",
  },
  {
    key: "gu",
    value: "ગુજરાતી",
    text: "古吉拉特语",
  },
];
export const NORMAL_APP = {
  us: {
    text: i18n.us,
    langList: EN_LANG_LIST,
  },
  eea: {
    text: i18n.eea,
    langList: EEA_LANG_LIST,
  },
  row: {
    text: i18n.otherRegion,
    langList: OTHER_LANG_LIST,
  },
};
export const ONLY_LANG_APP = [
  ...EN_LANG_LIST,
  {
    key: "hi-IN",
    value: "हिन्दी",
    text: "印地语",
  },
  {
    key: "pa-IN",
    value: "ਪੰਜਾਬੀ",
    text: "旁遮普语",
  },
  {
    key: "ml-IN",
    value: "മലയാളം",
    text: "马拉雅拉姆语",
  },
  {
    key: "gu",
    value: "ગુજરાતી",
    text: "古吉拉特语",
  },
];
export const SPE_LANG_APP = {
  sm_in: ONLY_LANG_APP,
  sm_id: OTHER_LANG_LIST,
  sme: OTHER_LANG_LIST
};
export const TITLE_DESC = {
  us: i18n.forUserUs,
  eea: i18n.forUserEea,
  row: i18n.forUserOther
};
export const VERSION_TEXT_MAP = {
  us: i18n.us,
  eea: i18n.eea,
  row: i18n.otherRegion,
};